import { Box, BoxProps } from '@mui/system';
import { useTranslation } from '@scorenco/core';

import { T_KEYS } from '../../translations';

import { useCompetitionRankingContext } from './CompetitionRankingContext';

type CompetitionRankingInfoHeaderProps = BoxProps;

export const CompetitionRankingInfoHeader = ({
  sx,
  ...rest
}: CompetitionRankingInfoHeaderProps) => {
  const { columns } = useCompetitionRankingContext();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '3rem',
        alignItems: 'center',
        textTransform: 'uppercase',
        fontSize: '0.65rem',
        fontWeight: 'bold',
        ...sx,
      }}
      className="competition-ranking-info-header"
      {...rest}
    >
      {columns.map((col) => (
        <Box
          key={col}
          className={['cell', col].filter(Boolean).join(' ')}
          sx={[
            {
              textAlign: 'center',
              flex: '0 0 2rem',
              letterSpacing: '-0.05em',
            },
            col === 'gnp' && {
              flex: '0 0 3.4rem',
            },
            col === 'gp' && {
              flex: '0 0 2.8rem',
            },
            col === 'sets' && {
              flex: '0 0 5.5rem',
            },
            col === 'serie' && {
              flex: '0 0 6rem',
            },
          ]}
        >
          {t(
            T_KEYS[
              `COMPETITION_RANKING_CELL_${col.toUpperCase()}` as keyof typeof T_KEYS
            ]
          )}
        </Box>
      ))}
    </Box>
  );
};
